import React, { useState } from "react";
import { get } from "util/requests";
import styles from "./queries.module.css";
import QueryTable from "./components/query_table";
import TableFileDownload from "ui/table_file_download";
import { useSelector } from "react-redux";

export default function Queries() {
  const study_id = useSelector((state) => state.study.active_study_id);
  const user_data = useSelector((state) => state.user.userData);
  const study_name = user_data.studies.find((s) => s.id === study_id)?.name;

  const getFunction = () =>
    get("/download_queries", {
      params: {
        domain_code: "all",
      },
    });

  return (
    <div className={styles.flex}>
      <div className={styles.header}>
        <div>
          <h3>Queries</h3>
        </div>
        <div>
          <TableFileDownload
            getFunction={getFunction}
            fileName={`${study_name.toLowerCase().replaceAll(" ", "_")}_query_export`}
          />
        </div>
      </div>
      <QueryTable />
    </div>
  );
}
